'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$AvailableCredentials(credentials, policy) {
  this.Lq = null;
  this.YD = null;
  this.Lq = credentials;
  this.YD = policy;
}
export { $c_Lpresto_types$proto$AvailableCredentials as $c_Lpresto_types$proto$AvailableCredentials };
$p = $c_Lpresto_types$proto$AvailableCredentials.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$AvailableCredentials;
/** @constructor */
function $h_Lpresto_types$proto$AvailableCredentials() {
}
export { $h_Lpresto_types$proto$AvailableCredentials as $h_Lpresto_types$proto$AvailableCredentials };
$h_Lpresto_types$proto$AvailableCredentials.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$AvailableCredentials)) {
    var x = this.Lq;
    var x$2 = x$0.Lq;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      return (this.YD === x$0.YD);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "AvailableCredentials";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Lq;
  }
  if ((n === 1)) {
    return this.YD;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$AvailableCredentials(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kv)));
}
export { $isArrayOf_Lpresto_types$proto$AvailableCredentials as $isArrayOf_Lpresto_types$proto$AvailableCredentials };
var $d_Lpresto_types$proto$AvailableCredentials = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$AvailableCredentials, "presto.types$proto$AvailableCredentials", ({
  kv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$AvailableCredentials as $d_Lpresto_types$proto$AvailableCredentials };
//# sourceMappingURL=presto.types$proto$-Available-Credentials.js.map
